import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

export const GmTabsSkeleton = () => {
  return (
    <div className="h-11 w-full md:w-fit gap-1 flex">
      <SkeletonParent className="rounded-[1.375rem] max-md:w-full">
        <SkeletonChild className="h-11 w-full md:w-25 rounded-[inherit]" />
      </SkeletonParent>
      <SkeletonParent className="rounded-[1.375rem] max-md:w-full">
        <SkeletonChild className="h-11 w-full md:w-[7.813rem] rounded-[inherit]" />
      </SkeletonParent>
    </div>
  );
};
